import { resolvePartType } from './partTypes';

// Currencies with conversion rates from JPY
export const CURRENCIES = {
  JPY: { symbol: '¥', rate: 1 },
  USD: { symbol: '$', rate: 0.0067 },
  AED: { symbol: 'د.إ', rate: 0.0245 },
  EUR: { symbol: '€', rate: 0.0062 },
  GBP: { symbol: '£', rate: 0.0053 },
  GEL: { symbol: '₾', rate: 0.018 },
  RUB: { symbol: '₽', rate: 0.61 }
};

// Format price in selected currency
export const formatPrice = (jpy, currency = 'JPY') => {
  const cur = CURRENCIES[currency] || CURRENCIES.JPY;
  return `${cur.symbol}${Math.round(jpy * cur.rate).toLocaleString()}`;
};

// Country → Cities mapping
export const COUNTRY_CITIES = {
  'Japan': [
    'Aichi', 'Akita', 'Aomori', 'Asahikawa', 'Chiba', 'Fukui', 'Fukuoka',
    'Fukushima', 'Gifu', 'Hachioji', 'Hakodate', 'Hamamatsu', 'Higashiosaka',
    'Himeji', 'Hiroshima', 'Ichikawa', 'Kagoshima', 'Kanazawa', 'Kawasaki',
    'Kitakyushu', 'Kobe', 'Kochi', 'Kumamoto', 'Kyoto', 'Maebashi', 'Matsudo',
    'Matsuyama', 'Mito', 'Miyazaki', 'Nagano', 'Nagasaki', 'Nagoya', 'Naha',
    'Niigata', 'Nishinomiya', 'Okayama', 'Oita', 'Osaka', 'Saitama', 'Sakai',
    'Sagamihara', 'Sapporo', 'Sendai', 'Shizuoka', 'Takatsuki', 'Tokyo',
    'Toyama', 'Toyota', 'Toyohashi', 'Utsunomiya', 'Wakayama', 'Yokohama', 'Yokosuka',
  ],
  'UAE': [
    'Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman', 'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain',
  ],
  'Saudi Arabia': [
    'Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Khobar', 'Dhahran', 'Tabuk', 'Taif', 'Abha', 'Jubail', 'Yanbu',
  ],
  'Kuwait': ['Kuwait City', 'Hawalli', 'Salmiya', 'Jahra', 'Farwaniya', 'Ahmadi'],
  'Bahrain': ['Manama', 'Riffa', 'Muharraq', 'Hamad Town', 'Isa Town'],
  'Qatar': ['Doha', 'Al Wakrah', 'Al Khor', 'Al Rayyan', 'Umm Salal'],
  'Oman': ['Muscat', 'Salalah', 'Sohar', 'Nizwa', 'Sur', 'Ibri'],
  'Georgia': ['Tbilisi', 'Batumi', 'Kutaisi', 'Rustavi', 'Poti', 'Zugdidi', 'Gori'],
  'Russia': [
    'Moscow', 'St. Petersburg', 'Vladivostok', 'Novosibirsk', 'Yekaterinburg',
    'Khabarovsk', 'Krasnoyarsk', 'Kazan', 'Rostov-on-Don', 'Samara',
  ],
  'Kenya': ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Malindi'],
  'Tanzania': ['Dar es Salaam', 'Dodoma', 'Mwanza', 'Arusha', 'Zanzibar City'],
  'Uganda': ['Kampala', 'Entebbe', 'Jinja', 'Gulu', 'Mbarara'],
  'Mozambique': ['Maputo', 'Beira', 'Nampula', 'Quelimane', 'Matola'],
  'DR Congo': ['Kinshasa', 'Lubumbashi', 'Mbuji-Mayi', 'Kisangani', 'Goma'],
  'Zambia': ['Lusaka', 'Kitwe', 'Ndola', 'Livingstone', 'Kabwe'],
  'Zimbabwe': ['Harare', 'Bulawayo', 'Mutare', 'Gweru', 'Masvingo'],
  'South Africa': ['Johannesburg', 'Cape Town', 'Durban', 'Pretoria', 'Port Elizabeth'],
  'Nigeria': ['Lagos', 'Abuja', 'Kano', 'Port Harcourt', 'Ibadan'],
  'Ghana': ['Accra', 'Kumasi', 'Tamale', 'Tema', 'Takoradi'],
  'Pakistan': ['Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Peshawar', 'Quetta'],
  'Sri Lanka': ['Colombo', 'Kandy', 'Galle', 'Jaffna', 'Negombo'],
  'Bangladesh': ['Dhaka', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet'],
  'Myanmar': ['Yangon', 'Mandalay', 'Naypyidaw', 'Mawlamyine', 'Bago'],
  'Mongolia': ['Ulaanbaatar', 'Erdenet', 'Darkhan', 'Choibalsan'],
  'Chile': ['Santiago', 'Valparaiso', 'Concepcion', 'Antofagasta', 'Iquique'],
  'Peru': ['Lima', 'Arequipa', 'Trujillo', 'Callao', 'Cusco'],
  'Bolivia': ['La Paz', 'Santa Cruz', 'Cochabamba', 'Sucre', 'Oruro'],
  'Paraguay': ['Asuncion', 'Ciudad del Este', 'Encarnacion', 'San Lorenzo'],
  'Trinidad and Tobago': ['Port of Spain', 'San Fernando', 'Chaguanas', 'Arima'],
  'Jamaica': ['Kingston', 'Montego Bay', 'Spanish Town', 'Portmore'],
  'Guyana': ['Georgetown', 'Linden', 'New Amsterdam', 'Bartica'],
  'Suriname': ['Paramaribo', 'Lelydorp', 'Nieuw Nickerie'],
  'Cyprus': ['Nicosia', 'Limassol', 'Larnaca', 'Paphos', 'Famagusta'],
  'New Zealand': ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga'],
  'Fiji': ['Suva', 'Nadi', 'Lautoka', 'Labasa'],
  'Papua New Guinea': ['Port Moresby', 'Lae', 'Mount Hagen', 'Madang'],
  'Samoa': ['Apia'],
  'Tonga': ["Nuku'alofa"],
};

export const COUNTRIES = Object.keys(COUNTRY_CITIES).sort();

// Legacy exports for backward compatibility
export const JAPAN_CITIES = COUNTRY_CITIES['Japan'];
export const PORTS = JAPAN_CITIES;

// World shipping ports organized by country
export const WORLD_PORTS = {
  'Japan': ['Yokohama', 'Tokyo', 'Nagoya', 'Osaka', 'Kobe', 'Hakata', 'Kisarazu', 'Hitachinaka', 'Kawasaki', 'Toyohashi', 'Shimizu', 'Niigata', 'Hakodate', 'Otaru', 'Tomakomai', 'Fukuoka', 'Kitakyushu', 'Hiroshima', 'Sakai', 'Moji'],
  'UAE': ['Jebel Ali', 'Sharjah', 'Abu Dhabi', 'Fujairah', 'Ras Al Khaimah', 'Hamriyah', 'Ajman', 'Khor Fakkan'],
  'Saudi Arabia': ['Jeddah', 'Dammam', 'Jubail', 'Yanbu', 'King Abdullah Port'],
  'Kuwait': ['Shuwaikh', 'Shuaiba'],
  'Bahrain': ['Khalifa Bin Salman Port', 'Mina Salman'],
  'Qatar': ['Hamad Port', 'Doha Port'],
  'Oman': ['Sohar', 'Salalah', 'Muscat (Sultan Qaboos)', 'Duqm'],
  'Georgia': ['Poti', 'Batumi'],
  'Russia': ['Vladivostok', 'Novorossiysk', 'St. Petersburg', 'Vostochny', 'Korsakov'],
  'Kenya': ['Mombasa'],
  'Tanzania': ['Dar es Salaam', 'Zanzibar', 'Tanga'],
  'Uganda': ['Kampala (ICD)', 'Port Bell'],
  'Mozambique': ['Maputo', 'Beira', 'Nacala'],
  'DR Congo': ['Matadi', 'Boma'],
  'Zambia': ['Lusaka (ICD)', 'Nakonde'],
  'Zimbabwe': ['Harare (ICD)', 'Beitbridge'],
  'South Africa': ['Durban', 'Cape Town', 'Port Elizabeth', 'East London', 'Richards Bay'],
  'Nigeria': ['Lagos (Apapa)', 'Lagos (Tin Can)', 'Port Harcourt', 'Onne', 'Calabar'],
  'Ghana': ['Tema', 'Takoradi'],
  'Pakistan': ['Karachi', 'Port Qasim', 'Gwadar'],
  'Sri Lanka': ['Colombo', 'Hambantota'],
  'Bangladesh': ['Chittagong', 'Mongla'],
  'Myanmar': ['Yangon (Thilawa)', 'Sittwe'],
  'Mongolia': ['Ulaanbaatar (ICD)'],
  'Chile': ['Valparaiso', 'San Antonio', 'Iquique', 'Arica'],
  'Peru': ['Callao', 'Paita', 'Matarani'],
  'Bolivia': ['Arica (Chile)', 'Ilo (Peru)'],
  'Paraguay': ['Asuncion', 'Villeta'],
  'Trinidad and Tobago': ['Port of Spain', 'Point Lisas'],
  'Jamaica': ['Kingston'],
  'Guyana': ['Georgetown'],
  'Suriname': ['Paramaribo'],
  'Cyprus': ['Limassol', 'Larnaca'],
  'New Zealand': ['Auckland', 'Tauranga', 'Lyttelton', 'Wellington'],
  'Fiji': ['Suva', 'Lautoka'],
  'Papua New Guinea': ['Lae', 'Port Moresby'],
  'Samoa': ['Apia'],
  'Tonga': ["Nuku'alofa"],
  'UK': ['Felixstowe', 'Southampton', 'London Gateway', 'Tilbury', 'Bristol'],
  'USA': ['Los Angeles', 'Long Beach', 'New York', 'Houston', 'Savannah', 'Seattle', 'Newark'],
  'China': ['Shanghai', 'Shenzhen', 'Ningbo', 'Qingdao', 'Guangzhou', 'Tianjin', 'Xiamen', 'Dalian'],
  'South Korea': ['Busan', 'Incheon', 'Ulsan', 'Gwangyang'],
  'Thailand': ['Laem Chabang', 'Bangkok Port', 'Map Ta Phut'],
  'Malaysia': ['Port Klang', 'Tanjung Pelepas', 'Penang'],
  'Singapore': ['Singapore'],
  'India': ['Mumbai (JNPT)', 'Chennai', 'Mundra', 'Kandla', 'Kolkata', 'Cochin', 'Visakhapatnam'],
  'Turkey': ['Istanbul (Ambarli)', 'Mersin', 'Izmir', 'Gemlik', 'Trabzon'],
  'Egypt': ['Alexandria', 'Port Said', 'Damietta', 'Sokhna'],
  'Iraq': ['Umm Qasr', 'Basra'],
  'Iran': ['Bandar Abbas', 'Bushehr', 'Chabahar', 'Khorramshahr'],
  'Ethiopia': ['Djibouti (via)', 'Addis Ababa (ICD)'],
  'Sudan': ['Port Sudan'],
};

// Yard locations
export const DEFAULT_YARD_LOCATIONS = [
  { id: 'japan_yard', name: 'Japan Yard', city: '', country: 'Japan', flag: '🇯🇵' },
  { id: 'sharjah_yard', name: 'Sharjah Yard', city: 'Sharjah', country: 'UAE', flag: '🇦🇪' },
];

// Get yards from appConfig (admin can add custom yards) + defaults
export function getYardLocations() {
  try {
    const cfg = JSON.parse(localStorage.getItem('bigstar_appConfig') || '{}');
    const custom = cfg.custom_yards || [];
    const all = [...DEFAULT_YARD_LOCATIONS, ...custom];
    // Deduplicate by id
    const seen = new Set();
    return all.filter(y => { if (seen.has(y.id)) return false; seen.add(y.id); return true; });
  } catch { return DEFAULT_YARD_LOCATIONS; }
}

export function getYardsByCountry() {
  const yards = getYardLocations();
  const grouped = {};
  yards.forEach(y => {
    const key = y.country || 'Other';
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(y);
  });
  return grouped;
}

// Destination countries
export const DEFAULT_DESTINATION_COUNTRIES = [
  { id: 'uae',          name: 'UAE',          flag: '🇦🇪' },
  { id: 'pakistan',      name: 'Pakistan',     flag: '🇵🇰' },
  { id: 'turkey',       name: 'Turkey',       flag: '🇹🇷' },
  { id: 'north_cyprus',  name: 'North Cyprus', flag: '🇨🇾' },
  { id: 'south_cyprus',  name: 'South Cyprus', flag: '🇨🇾' },
  { id: 'tanzania',     name: 'Tanzania',     flag: '🇹🇿' },
  { id: 'zimbabwe',     name: 'Zimbabwe',     flag: '🇿🇼' },
];

export function getDestinationCountries() {
  try {
    const cfg = JSON.parse(localStorage.getItem('bigstar_appConfig') || '{}');
    const custom = cfg.custom_destination_countries || [];
    const all = [...DEFAULT_DESTINATION_COUNTRIES, ...custom];
    const seen = new Set();
    return all.filter(c => { if (seen.has(c.id)) return false; seen.add(c.id); return true; });
  } catch { return DEFAULT_DESTINATION_COUNTRIES; }
}

// Zone system
export const POOL_ZONE = 'pool';
const DEFAULT_YARD_FOR_ZONES = 'hokkaido_yard';

function ensureByYard() {
  try {
    const raw = localStorage.getItem('bigstar_appConfig') || '{}';
    const cfg = JSON.parse(raw);
    if (cfg.zone_allocations_by_yard) return cfg.zone_allocations_by_yard;
    const flat = cfg.zone_allocations;
    if (flat && typeof flat === 'object' && Object.keys(flat).length > 0) {
      const byYard = { [DEFAULT_YARD_FOR_ZONES]: flat };
      const freshRaw = localStorage.getItem('bigstar_appConfig') || '{}';
      const freshCfg = JSON.parse(freshRaw);
      freshCfg.zone_allocations_by_yard = byYard;
      localStorage.setItem('bigstar_appConfig', JSON.stringify(freshCfg));
      return byYard;
    }
    return {};
  } catch { return {}; }
}

export function getZoneAllocations(yardId) {
  const yard = yardId || DEFAULT_YARD_FOR_ZONES;
  const byYard = ensureByYard();
  return byYard[yard] || {};
}

export function getLetterForCountry(yardId, countryId) {
  if (countryId === undefined) { countryId = yardId; yardId = DEFAULT_YARD_FOR_ZONES; }
  const alloc = getZoneAllocations(yardId);
  const letters = Object.keys(alloc).sort();
  for (const letter of letters) {
    if (alloc[letter] === countryId) return letter;
  }
  return '';
}

export function resolveTargetZone(unit) {
  const yard = unit.destination_yard;
  if (!yard) return { status: 'no_yard', zone: null };
  const country = unit.destination_country;
  if (!country) return { status: 'no_country', zone: null };
  const letter = getLetterForCountry(yard, country);
  if (!letter) return { status: 'unmapped', zone: null };
  const movable = unit.is_movable;
  if (movable === null || movable === undefined) return { status: 'movable_unknown', zone: null };
  const number = movable ? '1' : '2';
  return { status: 'ok', zone: letter + number };
}

export function getAllocatedZoneCodes(yardId) {
  const alloc = getZoneAllocations(yardId);
  const codes = [POOL_ZONE];
  for (const letter of Object.keys(alloc).sort()) {
    codes.push(letter + '1', letter + '2');
  }
  return codes;
}

// Country → flag emoji auto-lookup
const COUNTRY_FLAGS = {
  'Japan': '🇯🇵', 'UAE': '🇦🇪', 'Pakistan': '🇵🇰', 'Georgia': '🇬🇪', 'Russia': '🇷🇺',
  'Kenya': '🇰🇪', 'Tanzania': '🇹🇿', 'Uganda': '🇺🇬', 'Mozambique': '🇲🇿', 'DR Congo': '🇨🇩',
  'Zambia': '🇿🇲', 'Saudi Arabia': '🇸🇦', 'Kuwait': '🇰🇼', 'Bahrain': '🇧🇭', 'Qatar': '🇶🇦',
  'Oman': '🇴🇲', 'Azerbaijan': '🇦🇿', 'Kazakhstan': '🇰🇿', 'Uzbekistan': '🇺🇿', 'Turkmenistan': '🇹🇲',
  'Tajikistan': '🇹🇯', 'Kyrgyzstan': '🇰🇬', 'UK': '🇬🇧', 'USA': '🇺🇸', 'Germany': '🇩🇪',
  'Turkey': '🇹🇷', 'China': '🇨🇳', 'South Korea': '🇰🇷', 'Thailand': '🇹🇭', 'Malaysia': '🇲🇾',
  'Sri Lanka': '🇱🇰', 'Bangladesh': '🇧🇩', 'India': '🇮🇳', 'Nigeria': '🇳🇬', 'Ghana': '🇬🇭',
  'Ethiopia': '🇪🇹', 'Sudan': '🇸🇩', 'Egypt': '🇪🇬', 'Iraq': '🇮🇶', 'Iran': '🇮🇷',
  'Afghanistan': '🇦🇫', 'Myanmar': '🇲🇲', 'Cambodia': '🇰🇭', 'Philippines': '🇵🇭',
};
export function getFlagForCountry(country) {
  if (!country) return '📍';
  return COUNTRY_FLAGS[country] || COUNTRY_FLAGS[Object.keys(COUNTRY_FLAGS).find(k => k.toLowerCase() === country.toLowerCase())] || '📍';
}

// Backwards compatible export
export const YARD_LOCATIONS = DEFAULT_YARD_LOCATIONS;

// Transmission types
export const FUEL_TYPES = ['Diesel', 'Petrol', 'Hybrid', 'Electric', 'LPG', 'CNG', 'Other'];

export const TRANSMISSIONS = [
  'Automatic', 'Manual',
  'F5', 'F6', 'F7', 'F8',
  'CAT', 'CVT', 'DCT',
  'AT3', 'AT4', 'AT5', 'AT6', 'AT7', 'AT8', 'AT9', 'AT10',
  'MT5', 'MT6',
  'SMG', 'PDK', 'DSG',
  'Column Shift', 'Tiptronic',
];

// Drive systems
export const DRIVE_SYSTEMS = ['2WD', '4WD', 'AWD', 'FWD', 'RWD'];

// Steering
export const STEER_OPTIONS = ['Right', 'Left'];

// Vehicle grades/scores
export const GRADES = ['S', 'A', 'B', 'C', 'D', 'R', 'RA', '0', '1', '2', '3', '3.5', '4', '4.5', '5'];

// Cut types for vehicles
export const CUT_TYPES = [
  { id: 'half-cut', name: 'Half Cut' },
  { id: 'nose-cut', name: 'Nose Cut' },
  { id: 'ckd',      name: 'CKD' },
  { id: 'roof-cut', name: 'Roof Cut' },
  { id: 'skd',      name: 'SKD' },
];

// Categories of cuttable items (items customers can request parts from)
export const CUTTABLE_CATEGORIES = ['Half Cut', 'Nose Cut', 'CKD', 'SKD', 'Roof Cut', 'CBU', 'Half Cut (H/CUT)', 'H/CUT W/O Catalyst', 'CKD W/O Engine', 'CKD W/O Scrap (Frame etc)', 'CBU (Complete Built Unit)'];

// Which part catalog categories are available from each source type
export const CUT_SOURCE_CATALOG = {
  full_car: ['all'],
  'Half Cut': ['Engine & Transmission', 'Engine Bundles', 'Cooling & AC', 'Suspension & Steering', 'Brakes', 'Lights', 'Body Panels', 'Glass', 'Interior', 'Electrical', 'Mirrors', 'Doors & Locks', 'Windows & Regulators'],
  'Half Cut (H/CUT)': ['Engine & Transmission', 'Engine Bundles', 'Cooling & AC', 'Suspension & Steering', 'Brakes', 'Lights', 'Body Panels', 'Glass', 'Interior', 'Electrical', 'Mirrors'],
  'Nose Cut': ['Lights', 'Body Panels', 'Cooling & AC', 'Mirrors'],
  'Roof Cut': ['Glass', 'Interior'],
  'CKD': ['all'],
  'SKD': ['all'],
  'CBU': ['all'],
  'CBU (Complete Built Unit)': ['all'],
};

// ── Pricing helpers ───────────────────────────────────────────

// Auto-calculate total_jpy from all *_jpy fields in a pricing object
export const calcTotalJpy = (pricing) => {
  if (!pricing) return 0;
  const jpyFields = [
    'unit_price_jpy', 'recycle_fee_jpy', 'misc_jpy', 'bid_fee_jpy',
    'transport_jpy', 'vanning_jpy', 'freight_jpy', 'commission_jpy',
  ];
  return jpyFields.reduce((sum, key) => sum + (Number(pricing[key]) || 0), 0);
};

// Convert JPY to any currency using app_config rates
// Rates format: { USD: 1, JPY: 149.5, AED: 3.67, ... } (all relative to USD)
export const convertFromJpy = (amountJpy, targetCurrency, rates) => {
  if (!rates || !amountJpy) return 0;
  const jpyRate = rates.JPY || 149.5;
  const targetRate = rates[targetCurrency] || 1;
  return (amountJpy / jpyRate) * targetRate;
};

// CSV export utility
export const exportCSV = (items, filename = 'export.csv', opts = {}) => {
  if (!items.length) { alert('No data to export.'); return; }
  const fin = opts.includeFinancials !== false;
  const headers = [
    'SKU', 'Name', 'Type', 'Subtype', 'Status',
    'Year', 'Chassis', 'Make', 'Model', 'Engine', 'Displacement', 'Mileage (km)',
    'Score', 'Grade', 'Color', 'Transmission', 'Drive System', 'Steering', 'Seats',
    'Port', 'City',
    'Engine Name', 'Manufacturer',
    'Part Name', 'Category', 'Condition', 'Fitment', 'Quantity',
    ...(fin ? ['Cost (JPY)', 'Price (JPY)'] : []),
    'Days in Stock', 'Added Date',
  ];
  const getSubtype = (i) => resolvePartType(i);
  const rows = items.map(i => [
    i.sku || '',
    i.make ? `${i.make} ${i.model}` : i.engineName || i.partName || '',
    i.make ? 'Vehicle' : i.engineName ? 'Engine' : 'Part',
    getSubtype(i),
    i.status || '',
    i.year || '', i.chassis || '', i.make || '', i.model || '',
    i.engineCode || '', i.displacement || '', i.mileage || '',
    i.score || '', i.grade || '',
    i.color || '', i.transmission || '', i.driveSystem || '', i.steer || '', i.seats || '',
    i.port || '', i.city || '',
    i.engineName || '', i.manufacturer || '',
    i.partName || '', i.category || '', i.condition || '', i.fitment || '', i.quantity || '',
    ...(fin ? [i.costJPY || '', i.priceJPY || ''] : []),
    i.daysInStock || '', i.createdAt || '',
  ]);
  const csv = [headers, ...rows]
    .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
};

// User roles and permissions
export const ROLES = {
  head_admin: {
    name: 'Head Admin',
    nav: ['dashboard', 'inventory', 'bulkParts', 'marketPrices', 'containers', 'cutPlans', 'yardMap', 'selectionOrders', 'priceQuotes', 'invoices', 'payments', 'requests', 'customers', 'employees', 'tasks', 'scan', 'yardPricing', 'walkInCustomers', 'yardHistory', 'websiteCars', 'inquiries', 'tradeApplications', 'auditLog', 'settings', 'cms'],
    canAdd: true,
    canPrice: true,
    canContainer: true,
    canDelete: true,
    canManageAdmins: true,
    canManageSystem: true,
    isHeadAdmin: true,
    canSeeFinancials: true,
  },
  admin: {
    name: 'Administrator',
    nav: ['dashboard', 'inventory', 'bulkParts', 'marketPrices', 'containers', 'cutPlans', 'yardMap', 'selectionOrders', 'priceQuotes', 'invoices', 'payments', 'requests', 'customers', 'employees', 'tasks', 'scan', 'yardPricing', 'walkInCustomers', 'yardHistory', 'websiteCars', 'inquiries', 'tradeApplications', 'auditLog', 'settings', 'cms'],
    canAdd: true,
    canPrice: true,
    canContainer: true,
    canDelete: true,
    canSeeFinancials: true,
  },
  accountant: {
    name: 'Accountant',
    nav: ['dashboard', 'pricing', 'priceQuotes', 'inventory', 'containers', 'invoices', 'payments', 'customers', 'scan', 'tasks'],
    canAdd: false,
    canPrice: true,
    canPricing: true,
    canContainer: true,
    canDelete: false,
    canSeeFinancials: true,
  },
  uploader: {
    name: 'Data Entry',
    nav: ['dashboard', 'inventory', 'bulkParts', 'tasks'],
    canAdd: true,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    canSeeFinancials: true,
  },
  japan_yard: {
    name: 'Japan Yard',
    nav: ['dashboard', 'inventory', 'bulkParts', 'containers', 'cutPlans', 'scan', 'yardPricing', 'tasks'],
    canAdd: true,
    canPrice: false,
    canContainer: true,
    canLoad: true,
    canDelete: false,
    canSeeFinancials: true,
  },
  destination: {
    name: 'Destination Team',
    nav: ['dashboard', 'containers', 'scan', 'tasks'],
    canAdd: false,
    canPrice: false,
    canContainer: false,
    canArrival: true,
    canDelete: false,
    canSeeFinancials: true,
  },
  yard_sales: {
    name: 'Yard Sales',
    nav: ['dashboard', 'inventory', 'yardPricing', 'walkInCustomers', 'yardHistory', 'scan', 'tasks', 'settings'],
    canAdd: true,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    canYardBid: true,
    canVerifyPayment: true,
    canSeeFinancials: false,
  },
  yard_operator: {
    name: 'Yard Operator',
    nav: ['dashboard', 'inventory', 'yardMap', 'scan', 'tasks'],
    canAdd: true,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    canSeeFinancials: false,
  },
  yard_manager: {
    name: 'Yard Manager',
    nav: ['dashboard', 'inventory', 'yardMap', 'scan', 'tasks'],
    canAdd: true,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    canSeeFinancials: false,
  },
  web_content: {
    name: 'Web Content',
    nav: ['cms'],
    canAdd: false,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    isCMS: true,
    canSeeFinancials: false,
  },
  customer: {
    name: 'Customer',
    nav: ['dashboard', 'inventory', 'myStock', 'containers', 'invoices', 'requests', 'settings'],
    isCustomer: true,
    canAdd: false,
    canPrice: false,
    canContainer: false,
    canDelete: false,
    canSeeFinancials: false,
  }
};

// Vehicle makes
export const VEHICLE_MAKES = [
  'Toyota',
  'Nissan',
  'Honda',
  'Mazda',
  'Subaru',
  'Mitsubishi',
  'Suzuki',
  'Lexus',
  'Infiniti'
];

// Part categories
export const PART_CATEGORIES = [
  'Engine',
  'Turbo',
  'Exhaust',
  'Suspension',
  'Brakes',
  'Interior',
  'Exterior',
  'Electronics',
  'Transmission',
  'Drivetrain',
  'Wheels',
  'Body',
  'Half Cut',
  'Nose Cut',
  'CKD',
];

// Container statuses
export const CONTAINER_STATUSES = [
  { id: 'loading', name: 'Loading', color: 'yellow' },
  { id: 'in_transit', name: 'In Transit', color: 'blue' },
  { id: 'arrived', name: 'Arrived', color: 'green' },
  { id: 'cleared', name: 'Cleared', color: 'green' }
];

// Request statuses
export const REQUEST_STATUSES = [
  { id: 'pending', name: 'Pending', color: 'yellow' },
  { id: 'processing', name: 'Processing', color: 'blue' },
  { id: 'sourced', name: 'Sourced', color: 'green' },
  { id: 'cancelled', name: 'Cancelled', color: 'red' }
];
